/* ============
 * Client Transformer
 * ============
 *
 * The transformer for the client.
 */

import Transformer from './transformer';
import clientTypeTransformer from './clientType';

export default class ClientTransformer extends Transformer {

  static fetch(client) {
    return {
      id: client.id,
      clientNumber: client.client_number,
      name: client.name,
      active: client.active,
      subscribedAt: client.subscribed_at,
      companyName: client.company_name,
      description: client.description,
      clientGroupId: client.client_group_id,
      firstName: client.first_name,
      lastName: client.last_name,
      email: client.email,
      emails: client.emails,
      phoneNumber: client.phone_number,
      mobileNumber: client.mobile_number,
      streetName: client.street_name,
      secondStreetName: client.second_street_name,
      postalCode: client.postal_code,
      cityName: client.city_name,
      countryId: client.country_id,
      careOf: client.care_of,
      ordersCount: client.orders_count,
      billsCount: client.bills_count,
      totalValueInvoiced: client.total_value_invoiced,
      totalValueInvoicedDue: client.total_value_invoiced_due,
      invoiceSendMethod: client.invoice_send_method,
      picture: client.picture ? { url: client.picture } : undefined,
      typeId: client.type_id,
      clientTypeId: client.client_type_id,
      clientTypeName: client.client_type_name,
      createdAt: client.created_at,
      balance: client.balance,
      organizationNumber: client.organization_number,
      clientType:
        client.client_type !== undefined
          ? clientTypeTransformer.fetch(client.client_type)
          : [],
      addresses: client.client_addresses,
      deliveryAddress: client.delivery_address,
      contacts: client.client_contacts,
      externalCustomerNumber: client.external_customer_number,
      billingType: client.billing_type,
      automaticBilling: client.automatic_billing,
      billingInterval: client.billing_interval,
      startBilling: client.start_billing,
      billingMethodLocked: client.billing_method_locked,
      automateBillingMethodLocked: client.automate_billing_method_locked,
      priceFieldId: client.price_field_id,
      pricePercentageDiscount: client.price_percentage_discount,
      ehfBilling3_0: client.ehf_billing_3_0,
      isActive: client.is_active,
      dueDays: client.due_days,
      turnoverLastSent: client.turnover_last_sent,
      isProducer: client.is_producer,
      isSupplier: client.is_supplier,
      clientParent: client.client_parent,
      clientParentId: client.client_parent_id,
      billMainParent: client.bill_main_parent,
      marketplaces: client.marketplaces,
      manualProcessOrder: client.manual_process_order,
      syncToWoo: client.sync_to_woo,
      systemGenerated: client.system_generated,
      gln: client.gln,
      glnXKoord: client.gln_x_koord,
      glnYKoord: client.gln_y_koord,
      orderReference: client.order_reference,
      currencyId: client.currency_id === 0 ? 1 : client.currency_id,
      languageId: client.language_id,
      projectId: client.project_id,
      orderNote: client.order_note,
      receivables_account_id: client.receivables_account_id,
      custNo: client.cust_no,
    };
  }

  static send(client) {
    return {
      id: client.id,
      user_id: client.userId,
      type_id: client.typeId,
      client_group_id: client.clientGroupId,
      first_name: client.firstName,
      last_name: client.lastName,
      client_type: client.clientType,
      email: client.email,
      company_name: client.companyName,
      picture: client.picture && client.picture.file ? client.picture.file : '',
      organization_number: client.organizationNumber,
      invoice_send_method: client.invoiceSendMethod,
      externalCustomerNumber: client.externalCustomerNumber,
      billing_type: client.billingType,
      automatic_billing: client.automaticBilling,
      billing_interval: client.billingInterval,
      start_billing: client.startBilling,
      price_field_id: client.priceFieldId || '',
      price_percentage_discount: client.pricePercentageDiscount,
      is_active: client.isActive,
      due_days: client.dueDays,
      is_producer: client.isProducer,
      is_supplier: client.isSupplier,
      client_parent_id: client.clientParent.id,
      bill_main_parent: client.billMainParent,
      is_sub_client: client.isSubClient,
      manual_process_order: client.manualProcessOrder,
      sync_to_woo: client.syncToWoo,
      gln: client.gln,
      gln_x_koord: client.glnXKoord,
      gln_y_koord: client.glnYKoord,
      order_reference: client.orderReference,
      currency_id: client.currencyId,
      language_id: client.languageId,
      project_id: client.projectId,
      order_note: client.orderNote,
      receivables_account_id: client.receivables_account_id || '',
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/client.js